import '../../../styles/index.css'
import './CardMontagem.css';
import BotaoAdicionar from '../../Buttons/BotaoAdicionar/BotaoAdicionar';
import BotaoRemover from '../../Buttons/BotaoRemover/BotaoRemover';
import ExternalPageButton from '../../../assets/icons/External Page Icon Vermelho.svg';
import { formataPreço } from '../../../utils/preços';
import { formataNome } from '../../../utils/nomes';
import { Link } from 'react-router-dom';

function CardMontagem({ imagem, nome, preço, categoria, id, tipoBotao, onClick }) {

  return (

    <div className='cardMontagem container shadow'>

      <div className='divCardMontagem'>

        <img className='imgCardMontagem' src={imagem} alt="" data-cy="card-montagem-imagem"/>

        <p className='bt2' style={{width: '70%'}}>{formataNome(nome, 50)}</p>

      </div>

      <hr style={{margin: '12px 0'}}/>

      <div className='divCardMontagem'>

        <p className='bt2'>{`R$ ${formataPreço(preço.replace('.', ','))}`}</p>

        <Link to={`/Produto/${categoria}/${id}`} target="_blank" rel="noopener noreferrer" data-cy="card-montagem-link">
          <img src={ExternalPageButton} alt="" />
        </Link>

        {
          tipoBotao === 'Adicionar' ? <div type="button" data-bs-dismiss="modal" data-bs-target="#modalEscolherPeça" aria-label="Close"><BotaoAdicionar onClick={() => onClick(categoria, id)}/></div> : <BotaoRemover onClick={() => onClick(categoria)}/>
        }

      </div>

    </div>

  );
}

export default CardMontagem;
